import React from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({});

function Setting(props) {
  return null;
}

const mapStateToProps = (state) => {
  return {
    store: state,
    accountId: _get(state, "authData.accountId"),
  };
};

export default withStyles(styles)(connect(mapStateToProps, {})(Setting));
